import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';
import { dossierDetailComponent } from './dossierDetail.component';
import { DossierBasicInfoModule } from './dossierBasicInfo.module';
import { OverlayPanelModule } from 'primeng-lts/overlaypanel';

@NgModule({
  declarations: [dossierDetailComponent],
  imports: [
    TranslateModule,
    CommonModule,
    OverlayPanelModule,
    DossierBasicInfoModule
  ],
  exports: [dossierDetailComponent]
})
export class DossierDetailModule { }
